export const Y_AXIS_TICK_RATE = 5; // in days
export const CHART_DATA_TIME_PERIOD = 90; // in days
export const MINIMUM_MONTH_LABEL_GAP = 3; // in days
export const DEFAULT_SMOOTHING_INTERVAL = 3; // in days
export const GOOGLE_SHEETS_URL =
  'https://docs.google.com/spreadsheets/d/1UR33j_To2EPGI-ZgFurCcVnOLR_filYl9vIRFzu-_jU/export?format=csv&gid=0';
export const GOOGLE_SHEETS_METADATA_URL =
  'https://docs.google.com/spreadsheets/d/1UR33j_To2EPGI-ZgFurCcVnOLR_filYl9vIRFzu-_jU/export?format=csv&gid=48360649';

// Dataset indices - defines the order of chart datasets
export const DATASET_INDICES = {
  MEAN: 0, // Mean Estimate dataset
  P5: 1, // 5th Percentile dataset
  P95: 2, // 95th Percentile dataset
  INDICATOR: 3, // Indicator dataset (transparent bars for interactions)
};

export const COLORS = {
  primaryLine: '#6ebfe8',
  secondaryLine: '#e7f5fc',
  primaryAreaBg: '#f8fdff',
  primaryText: '#22262E',
  secondaryText: '#6F7680',
  axisStroke: '#E9EAEB',
  white: '#FFFFFF',
  // Interaction colors
  tooltipBorder: '#b7bbbc80', // equivalent to rgba(183, 187, 188, 0.50)
  indicatorHover: '#bee4f7',
  // Skeleton loader colors
  skeletonStroke: '#c6c9cc',
  // Projected label color
  projectedLabel: '#5FB9E6',
  // Projected line colors
  projectedMeanLine: '#A8DAF2',
  projectedSecondaryLine: '#DFF1FB',
};
